// extracted by mini-css-extract-plugin
module.exports = {"btn-overrides":"styles_btn-overrides__3e6XP","content":"styles_content__1BCY6","outline-btn-overrides":"styles_outline-btn-overrides__sMCJS"};